import { render, staticRenderFns } from "./sendPtenEmail.vue?vue&type=template&id=a1ca6a7e&scoped=true"
import script from "./sendPtenEmail.vue?vue&type=script&lang=js"
export * from "./sendPtenEmail.vue?vue&type=script&lang=js"
import style0 from "./sendPtenEmail.vue?vue&type=style&index=0&id=a1ca6a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ca6a7e",
  null
  
)

export default component.exports